<template>
  <div class="rg-history-setting-button-wrapper">
    <rg-history-setting-button
      :tooltipSettings="{
        text: '過去履歴表示',
        position: 'right',
      }"
      :style="buttonStyle"
      :class="buttonAdditionalClass"
    ></rg-history-setting-button>
  </div>
</template>

<script>
import RgHistorySettingButton from "./RgHistorySettingButton.vue";

export default {
  name: "RgHistorySettingButtonContainer",
  props: {
    isMobileDevice: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RgHistorySettingButton,
  },
  computed: {
    buttonAdditionalClass() {
      return { "mobile-menu-icon-button": this.isMobileDevice };
    },
    buttonStyle() {
      return this.isMobileDevice
        ? { position: "absolute", top: "14px", left: "280px", "z-index": 3 }
        : { position: "absolute", top: "14px", left: "200px", "z-index": 3 };
    },
  },
};
</script>

<style lang="scss" scoped>
.rg-history-setting-button-wrapper {
  ::v-deep .menu-icon-button {
    &.mobile-menu-icon-button {
      .menu-icon {
        height: 40px;
        width: 40px;
      }
    }
  }
}
</style>
